const {links} = require('../common');
const css = require('./mobile.scss');

module.exports = ({mainLinks, socialLinks, t}) => `
  ${links(mainLinks, {
    list: css.menu,
    itemContent: css.menuContent
  })}

  ${links(socialLinks, {
    list: css.social,
    item: css.socialItem
  })}

  <div class="${css.copyrights}">${t('closing_years')}</div>
`;



// WEBPACK FOOTER //
// ./templates/footer/mobile.js